export default __webpack_public_path__ + "static/media/sms.e188b9c7.svg";